import styled from 'styled-components';

export const TourSettingWrapper = styled.div``;

export const TourWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

export const MatterportContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const HotspotCompactInfoWrapper = styled.div`
  position: absolute;
  z-index: 21;
  bottom: 1rem;
  right: 1rem;
  opacity: 0;
  transform: translateX(1rem);
  transition: var(--transition-smooth);
  border-radius: 8px;
  background-color: var(--color-primary);
  padding: 1rem;
  width: 350px;
  height: auto;
  pointer-events: none;
  article {
    * {
      color: var(--color-text);
    }
    p:last-child {
      margin: 0;
    }

    figure {
      width: 100% !important;
      height: auto !important;
      img {
        width: 100% !important;
        height: auto !important;
      }
    }
  }

  &.active {
    opacity: 1;
    transform: none;
  }
`;
